import React, { Component } from 'react';
import MaterialTable from '@material-table/core';
import { observer } from 'mobx-react';
import { fetchWithAuth } from '../../Auth/GlobalFetchWithAuth';
import ServerStore from './ServerStore';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/AddCircleOutline';
import MainStore from '../../../MainStore';
import authStore from '../../Auth/AuthStore';

const ServerTable = observer(class EnvironmentTable extends Component {
    constructor(props) {
        super(props);
        this.columns = [
            { field: 'caption', title: 'Имя', width: 150 },
            { field: 'address', title: 'Адрес', width: 150 },
            { field: 'typeName', title: 'Тип', width: 150, defaultGroupOrder: 1 },
            { field: 'categoryName', title: 'Категория', width: 150 },
            { field: 'accountName', title: 'Контрагент', width: 150, defaultGroupOrder: !!props.accountId ? -1 : 0 },
            { field: 'ownerName', title: 'Ответственный', width: 150 },
            { field: 'accessProtocolName', title: 'Протокол подключения', width: 150 },
            { field: 'login', title: 'Пользователь', width: 150 },
            { field: 'password', title: 'Пароль', width: 150 },
            { field: 'projectName', title: 'Проект', width: 150 },
        ];

        this.state = {
            servers: []
        };

        this.load = this.load.bind(this);

        this.handleServerUpdate = this.handleServerUpdate.bind(this);

        ServerStore.setAutorunFunction(this.handleServerUpdate);
    };

    componentDidMount() {
        var scope = this;
        if (!authStore.isAuth) {
            authStore.openLogin(() => { scope.load(); });
            return;
        }
        else this.load();
    }

    load() {
        var scope = this;
        MainStore.setMaskVisible();
        fetchWithAuth(
            'api/Server?accountId=' + this.props.accountId,
            null
            ,
            'application/json',
            (result) => {
                scope.setState({ servers: result });
                MainStore.setMaskUnvisible();
            },
            'GET'
        );
    }

    openEditServerDialog(rowData) {
        ServerStore.openServerDialog(rowData);
    }

    deleteServer(rowData, resolve) {
    }

    openAddServerDialog() {
        ServerStore.openServerDialog({ description: '' });
    }

    handleServerUpdate(server) {
        let servers = this.state.servers.slice(0);
        var index = servers.findIndex(s => s.id === server.id);
        if (index > -1) {
            servers.splice(index, 1, server);
        }
        else {
            servers.push(server);
        }
        this.setState({ servers: servers });
    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    render() {
        return (
            <div className="kanban-columns-wrapper">
                <MaterialTable
                    title=""
                    columns={this.columns}
                    data={this.state.servers}
                    editable={{
                        onRowDelete: oldData =>
                            new Promise(resolve => {
                                this.deleteServer(oldData, resolve)
                            })
                    }}
                    actions={[
                        {
                            icon: 'add',
                            tooltip: 'Добавить',
                            isFreeAction: true,
                            onClick: this.openAddServerDialog
                        },
                        {
                            icon: 'edit',
                            tooltip: 'Редактировать',
                            isFreeAction: false,
                            onClick: (event, rowData) => {
                                this.openEditServerDialog(rowData);
                            }
                        }
                    ]}
                    options={{
                        actionsColumnIndex: -1,
                        grouping: true
                    }}
                />
            </div>
        );
    }
});

export default ServerTable;